import JsonURL from '@jsonurl/jsonurl';
import { useLocation } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
function parseUrl(str) {
    if (!str) {
        return undefined;
    }
    try {
        return JsonURL.parse(str, { AQF: true });
    }
    catch (_a) {
        return undefined;
    }
}
let cachedID = uuid();
function getCacheKey(cacheBust) {
    if (cacheBust) {
        cachedID = cacheBust;
    }
    return cachedID;
}
export function useGetSearchURLData() {
    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const filters = parseUrl(searchParams.get('filters')) || {};
    const modifiers = parseUrl(searchParams.get('modifiers')) || {};
    const orderBy = parseUrl(searchParams.get('orderBy'));
    const cacheBust = searchParams.get('_cacheKey');
    const key = getCacheKey(cacheBust);
    const query = searchParams.get('query') || '';
    return {
        query,
        filters,
        modifiers,
        orderBy,
        key,
    };
}
